"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const event = {
    pageVisit: 'Page visit',
    queueAction: 'Queue action',
    request: 'Request',
};
class MixpanelService {
    constructor(Mixpanel, token, serviceName) {
        if (token !== '') {
            this.instance = Mixpanel.init(token) || Mixpanel;
        }
        this.serviceName = serviceName;
        this.event = event;
    }
    setDistinctId(distinctId) {
        this.distinctId = distinctId;
    }
    setUser(user) {
        if (this.instance) {
            if (this.instance.identify) {
                this.instance.identify(user.id);
            }
            this.instance.people.set(user.id, user);
            this.setDistinctId(user.id);
        }
        else {
            console.info('Track user:', user);
        }
    }
    setServiceName(serviceName) {
        this.serviceName = serviceName;
    }
    trackEvent(eventTitle, data) {
        if (this.instance) {
            const dataHasDistinctId = lodash_1.default.has(data, 'distinct_id');
            if (dataHasDistinctId === false && this.distinctId) {
                lodash_1.default.set(data, 'distinct_id', this.distinctId);
            }
            if (this.serviceName) {
                lodash_1.default.set(data, 'Service', this.serviceName);
            }
            this.instance.track(eventTitle, data);
        }
        else {
            console.info('Track event:', eventTitle, data);
        }
    }
}
exports.default = MixpanelService;
